var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.authorized)?_c('b-dropdown-item',{attrs:{"to":_vm.to,"variant":_vm.color},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }